import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import {TextField, Button, MenuItem} from '@material-ui/core/';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import InputMask from 'react-input-mask';
import {useStyles} from "./styles";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {useParams, useHistory} from "react-router-dom";
import { toast  } from 'react-toastify';
import api from '../../../services/api';
import ImageUploading from 'react-images-uploading';
import blackProfile from '../../../assets/imgs/blank-profile.png'

import { ehProprioAssessor, mensagemErro, nomePerfil } from "../../../services/acesso";
import LinkGerado from "../../../components/LinkGerado";

const GreenCheckbox = withStyles({
    root: {
      color: green[400],
      '&$checked': {
        color: green[600],
      },
    },
    checked: {},
  })((props) => <Checkbox color="default" {...props} />);


 

const FormUser = (props) => {

    const classes = useStyles();

    const history = useHistory()
    let { id } = useParams();
     
    const [active,setActive] = useState(true)
    const [name,setName] = useState("")

    const [cep,setCep] = useState("")
    const [logradouro,setLogradouro] = useState("")
    const [neighborhood,setNeighborhood] = useState("")
    const [number,setNumber] = useState("")
    const [complement,setComplement] = useState("")
    const [city,setCity] = useState("")
    const [state,setState] = useState("")
    const [telephone,setTelephone] = useState("")
    const [ramal,setRamal] = useState("")

    const [email,setEmail] = useState("")
    const [password,setPassword] = useState("")


    const [cargo, setCargo] = useState("")
    const [perfil, setPerfil] = useState("assessor")
    const [acoesExtras, setAcoesExtras] = useState([])
    const [catalogo, setCatalogo] = useState([])
    const [perfis, setPerfis] = useState([])
    const [linkSenha, setLinkSenha] = useState(null)
    const [proprio, setProprio] = useState(false)
    

    const [errorEmail,setErrorEmail] = useState(false)
    const [errorEmailMsg,setErrorEmailMsg] = useState("")


    const [errorName,setErrorName] = useState(false)
    const [errorNameMsg,setErrorNameMsg] = useState("")

    const [errorPassword,setErrorPassword] = useState(false)
    const [errorPasswordMsg,setErrorPasswordMsg] = useState("")


    const [errorLogradouro,setErrorLogradouro] = useState(false)
    const [errorLogradouroMsg,setErrorLogradouroMsg] = useState("")
    

    const [errorNeighborhood,setErrorNeighborhood] = useState(false)
    const [errorNeighborhoodMsg,setErrorNeighborhoodMsg] = useState("")
    

    const [errorCity,setErrorCity] = useState(false)
    const [errorCityMsg,setErrorCityMsg] = useState("")

    const [errorState,setErrorState] = useState(false)
    const [errorStateMsg,setErrorStateMsg] = useState("")

    const [images, setImages] = React.useState([]);

    const maxNumber = 69;
  
    const handleImage = (imageList, addUpdateIndex) => {
      setImages(imageList);
    };
  

    const UFS =  [
        {"nome": "", "sigla": ""},
        {"nome": "Acre", "sigla": "AC"},
        {"nome": "Alagoas", "sigla": "AL"},
        {"nome": "Amapá", "sigla": "AP"},
        {"nome": "Amazonas", "sigla": "AM"},
        {"nome": "Bahia", "sigla": "BA"},
        {"nome": "Ceará", "sigla": "CE"},
        {"nome": "Distrito Federal", "sigla": "DF"},
        {"nome": "Espírito Santo", "sigla": "ES"},
        {"nome": "Goiás", "sigla": "GO"},
        {"nome": "Maranhão", "sigla": "MA"},
        {"nome": "Mato Grosso", "sigla": "MT"},
        {"nome": "Mato Grosso do Sul", "sigla": "MS"},
        {"nome": "Minas Gerais", "sigla": "MG"},
        {"nome": "Pará", "sigla": "PA"},
        {"nome": "Paraíba", "sigla": "PB"},
        {"nome": "Paraná", "sigla": "PR"},
        {"nome": "Pernambuco", "sigla": "PE"},
        {"nome": "Piauí", "sigla": "PI"},
        {"nome": "Rio de Janeiro", "sigla": "RJ"},
        {"nome": "Rio Grande do Norte", "sigla": "RN"},
        {"nome": "Rio Grande do Sul", "sigla": "RS"},
        {"nome": "Rondônia", "sigla": "RO"},
        {"nome": "Roraima", "sigla": "RR"},
        {"nome": "Santa Catarina", "sigla": "SC"},
        {"nome": "São Paulo", "sigla": "SP"},
        {"nome": "Sergipe", "sigla": "SE"},
        {"nome": "Tocantins", "sigla": "TO"}
    ];

    const handleActive = (event) => {
        setActive(event.target.checked)
    };


    const handleName = (event) => {
        if(event.target.value){
            setErrorName(false)
            setErrorNameMsg("")
        }
        setName(event.target.value)
    };


    const handleCep = (event) => {
        let cep = event.target.value.replace(/[^0-9]/g, '')
        setCep(cep)
        if(cep.length === 8){
            fetch(`https://viacep.com.br/ws/${cep}/json/`)
            .then((res) => res.json())
            .then((data) => {

                if(data.erro && data.erro == true){
                    return false;
                }
    
                setLogradouro(data.logradouro)
                setNeighborhood(data.bairro)
                setCity(data.localidade)
                // console.log(data.uf)
                // setState(data.uf)

                var state = "";
                UFS.map((uf)=>{
                    if(uf.sigla == data.uf){
                        state = uf
                        console.log(state)
                        setState(state)
                    }
                })
    
            }).catch((error) =>{
                alert("Erro")
            });
        }

    };

    const handleLogradouro = (event) => {
        if(event.target.value){
            setErrorLogradouro(false)
            setErrorLogradouroMsg("")
        }

        setLogradouro(event.target.value)
    };

    const handleNumber = (event) => {
        setNumber(event.target.value.replace(/[^0-9]/g, ''))
    };

    const handleRamal = (event) => {
        setRamal(event.target.value.replace(/[^0-9]/g, ''))
    };

    const handleComplement = (event) => {
        setComplement(event.target.value)
    };

    const handleNeighborhood = (event) => {
        if(event.target.value){
            setErrorNeighborhood(false)
            setErrorNeighborhoodMsg("")
        }

        setNeighborhood(event.target.value)
    };

    const handleCity = (event) => {

        if(event.target.value){
            setErrorCity(false)
            setErrorCityMsg("")
        }

        setCity(event.target.value)
    };

    const handleState = (value) => {
        if(value){
            setErrorState(false)
            setErrorStateMsg("")
        }
        setState(value)
    };

    const handleEmail = (event) => {

        if(event.target.value){
            setErrorEmail(false)
            setErrorEmailMsg("")
        }

        setEmail(event.target.value)
    }

    const handleTelephone = (event) => {
        let tel = event.target.value.replace(/[^0-9]/g, '')
        setTelephone(tel)
    }

    const handlePassword = (event) => {
        if(event.target.value){
            setErrorPassword(false)
            setErrorPasswordMsg("")
        }
        setPassword(event.target.value)
    }

    const handleCargo = (event) => {
        setCargo(event.target.value);
    }

    const perfilAtual = perfis.find((item) => item.id === perfil);
    const acoesDoPerfil = perfilAtual?.acoes || [];
    const extrasDisponiveis = catalogo.filter((acao) => acao.pode_extra && !acoesDoPerfil.includes(acao.id));

    const trocarPerfil = (novo) => {
        setPerfil(novo);
        const incluidas = perfis.find((item) => item.id === novo)?.acoes || [];
        setAcoesExtras((atuais) => atuais.filter((acao) => !incluidas.includes(acao)));
    };

    const alternarExtra = (acaoId) => {
        setAcoesExtras((atuais) => (
            atuais.includes(acaoId) ? atuais.filter((item) => item !== acaoId) : [...atuais, acaoId]
        ));
    };

    const gerarLinkSenha = async () => {
        try {
            const result = await api.post(`assessor/${id}/redefinicao-senha`);
            setLinkSenha(result.data);
            toast.success(result.data?.message || "Link de redefinição gerado");
        } catch (e) {
            toast.error(mensagemErro(e, "Não foi possível gerar o link"));
        }
    };

    useEffect(() => {
        (async () => {
            try {
                try {
                    const catalogoResult = await api.get("acoes");
                    setCatalogo(catalogoResult.data?.acoes || []);
                    setPerfis(catalogoResult.data?.perfis || []);
                } catch (erroCatalogo) {
                    toast.error(mensagemErro(erroCatalogo, "Não foi possível carregar os perfis"));
                }

                if(id) {
                    const result = await api.get(`assessor/${id}`)
                    const data = result?.data
                    setActive(Boolean(data.active))
                    setName(data.name)
                    setEmail(data.email)
                    setPerfil(data.perfil || "assessor")
                    setAcoesExtras(Array.isArray(data.acoes_extras) ? data.acoes_extras : [])
                    setProprio(ehProprioAssessor(id, data.email))
                    setCep(data.zip_code)
                    setLogradouro(data.logradouro)
                    setNeighborhood(data.neighborhood)
                    setComplement(data.complement)
                    setCity(data.city)
                    setTelephone(data.telephone)
                    setRamal(data.ramal)
                    setCargo(data.cargo)
                    if(data.image){
                        setImages([{"data_url":data.image}])
                    }

                    var state = "";
                    UFS.map((uf)=>{
                        if(uf.sigla == data.state){
                            state = uf
                            console.log(state)
                            setState(state)
                        }
                    })
            
                   
                    setNumber(data.number)
                }

            }catch(e){
                toast.error(mensagemErro(e, "Ocorreu um erro ao carregar o usuário"))
            }
          
          })()
    },[])

    const validationFields = async () => {   
        let result = true
        if(!name){
            setErrorName(true)
            setErrorNameMsg("Campo Obrigátorio")
            result = false
        }

        if(!email){
            setErrorEmail(true)
            setErrorEmailMsg("Campo Obrigátorio")
            result = false
        }

        if(!id && (!password || password.length < 8)){
            setErrorPassword(true)
            setErrorPasswordMsg("A senha precisa ter no mínimo 8 caracteres")
            result = false
        }

        if(!logradouro){
            setErrorLogradouro(true)
            setErrorLogradouroMsg("Campo Obrigátorio")
            result = false
        }

        if(!neighborhood){
            setErrorNeighborhood(true)
            setErrorNeighborhoodMsg("Campo Obrigátorio")
            result = false
        }

        if(!city){
            setErrorCity(true)
            setErrorCityMsg("Campo Obrigátorio")
            result = false
        }
 
        if(!state){
            setErrorState(true)
            setErrorStateMsg("Campo Obrigátorio")
            result = false
        }

        return result
    }

    const clearErrorsFields = () => {  

        setErrorName(false)
        setErrorNameMsg("")

        setErrorEmail(false)
        setErrorEmailMsg("")

        setErrorPassword(false)
        setErrorPasswordMsg("")

        setErrorLogradouro(false)
        setErrorLogradouroMsg("")

        setErrorPassword(false)
        setErrorLogradouroMsg("")

        setErrorNeighborhood(false)
        setErrorNeighborhoodMsg("")

        setErrorCity(false)
        setErrorCityMsg("")

        setErrorState(false)
        setErrorStateMsg("")
    }


    const handleSave = async () => {   
        let validation = await validationFields()
        if(validation){
            clearErrorsFields();
            let data = {
                active,
                image:images.length > 0 ? images[0]["data_url"] : null,
                email,
                name,
                zip_code: cep,
                logradouro,
                number,
                complement,
                neighborhood,
                city,
                state: state.sigla,
                telephone,
                ramal,
                cargo,
                perfil,
                acoes_extras: acoesExtras,
            };
            if (!id) {
                data.password = password;
            }
            if (proprio) {
                delete data.perfil;
                delete data.acoes_extras;
            }
     
            console.log(data)
            let config = {
                headers: {
                  "Content-Type": "application/json"
                  }
            }
              

            try {
                if(id){
                    await api.post(`/assessor/${id}/save`,data,config)
                    toast.success("Usuário editado com sucesso")
                    
                } else {
                    const result = await api.post("/assessor/save",data)
                    toast.success("Usuário cadatrado com sucesso")
                    const id_created = (result.data?.data?.id)
                    history.replace(`/user/${id_created}/edit`)
                }
              
            }catch(e){
                const response = e.response ? e.response : {};
                const data = response.data ? response.data : {};
                toast.error(mensagemErro(e, "Ocorreu um erro ao salvar o usuário"))
            }
        }
        

    };

    const opcoesPerfil = perfis.length ? perfis : [
        { id: "master", nome: "Master" },
        { id: "gestor", nome: "Gestor" },
        { id: "auditor", nome: "Auditor" },
        { id: "assessor", nome: "Assessor" },
        { id: "confirmacao", nome: "Confirmação" },
    ];

    return (
        <Container fixed>
            <h1 className={classes.title}>{!id ? "Novo Usuário" : "Editar Usuário"}</h1>
            <form className={classes.card} noValidate autoComplete="off">
                <section className={classes.section}>
                    <h2 className={classes.sectionTitle}>Dados</h2>
                    <Grid container spacing={2} alignItems="flex-start">
                        <Grid item xs={12} sm={2}>
                            <ImageUploading
                                multiple={false}
                                value={images}
                                onChange={handleImage}
                                maxNumber={1}
                                dataURLKey="data_url"
                            >
                                {({ imageList, onImageUpload, onImageUpdate }) => (
                                    <div>
                                        <img
                                            className={classes.photo}
                                            src={imageList[0] ? imageList[0].data_url : blackProfile}
                                            onClick={imageList[0] ? () => onImageUpdate(0) : onImageUpload}
                                            alt=""
                                        />
                                        <p className={classes.photoHint}>Clique para alterar</p>
                                    </div>
                                )}
                            </ImageUploading>
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <FormControlLabel
                                control={<GreenCheckbox checked={active} onChange={handleActive} name="active" disabled={proprio} />}
                                label="Ativo"
                            />
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField required label="Nome" error={errorName} helperText={errorNameMsg} value={name} onChange={handleName} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField required label="E-mail" error={errorEmail} helperText={errorEmailMsg} value={email} onChange={handleEmail} disabled={proprio} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField label="Cargo" value={cargo} onChange={handleCargo} fullWidth />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputMask mask="(99) 9999-9999" value={telephone} onChange={handleTelephone}>
                                        {(inputProps) => <TextField {...inputProps} label="Telefone" fullWidth />}
                                    </InputMask>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField label="Ramal" onChange={handleRamal} value={ramal} fullWidth />
                                </Grid>
                                <Grid item xs={12}>
                                    {!id && (
                                        <TextField required label="Senha" error={errorPassword} helperText={errorPasswordMsg || "Mínimo de 8 caracteres"} type="password" value={password} onChange={handlePassword} fullWidth />
                                    )}
                                    {id && proprio && (
                                        <p className={classes.note}>
                                            Para alterar seu nome, telefone ou senha, use <Link to="/meu-cadastro">Meu cadastro</Link>.
                                        </p>
                                    )}
                                    {id && !proprio && (
                                        <>
                                            <Button variant="outlined" type="button" onClick={gerarLinkSenha}>
                                                Gerar link de redefinição de senha
                                            </Button>
                                            <LinkGerado link={linkSenha?.link} email={linkSenha?.email || email} emailStatus={linkSenha?.email_status} />
                                        </>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </section>

                <section className={classes.section}>
                    <h2 className={classes.sectionTitle}>Endereço</h2>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <InputMask mask="99.999.999" value={cep} onChange={handleCep}>
                                {(inputProps) => <TextField {...inputProps} label="CEP" fullWidth />}
                            </InputMask>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField required label="Logradouro" error={errorLogradouro} helperText={errorLogradouroMsg} onChange={handleLogradouro} value={logradouro} fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <TextField label="Número" onChange={handleNumber} value={number} fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <TextField label="Complemento" onChange={handleComplement} value={complement} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField required label="Bairro" error={errorNeighborhood} helperText={errorNeighborhoodMsg} onChange={handleNeighborhood} value={neighborhood} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField required label="Cidade" error={errorCity} helperText={errorCityMsg} onChange={handleCity} value={city} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Autocomplete
                                id="state"
                                options={UFS}
                                onChange={(event, newInputValue) => handleState(newInputValue)}
                                value={state}
                                getOptionLabel={(option) => option.nome || ""}
                                renderInput={(params) => (
                                    <TextField {...params} label="Estado" error={errorState} helperText={errorStateMsg} fullWidth />
                                )}
                            />
                        </Grid>
                    </Grid>
                </section>

                <section className={classes.section}>
                    <h2 className={classes.sectionTitle}>Acesso</h2>
                    {proprio && (
                        <p className={classes.note}>O perfil e as ações extras do seu usuário não podem ser alterados aqui.</p>
                    )}
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                select
                                label="Perfil"
                                value={perfil}
                                onChange={(event) => trocarPerfil(event.target.value)}
                                disabled={proprio}
                                fullWidth
                            >
                                {opcoesPerfil.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>{item.nome || nomePerfil(item.id)}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>
                    <p className={classes.photoHint}>O que este perfil pode fazer</p>
                    <ul className={classes.abilityList}>
                        {acoesDoPerfil.map((acaoId) => {
                            const acao = catalogo.find((item) => item.id === acaoId);
                            return <li className={classes.abilityItem} key={acaoId}>{acao?.descricao || acaoId}</li>;
                        })}
                    </ul>
                    {!proprio && (
                        <div style={{ marginTop: 20 }}>
                            <p className={classes.photoHint}>Ações extras para esta pessoa</p>
                            {extrasDisponiveis.length === 0 && (
                                <p className={classes.note}>Este perfil já inclui as ações que podem ser liberadas à parte.</p>
                            )}
                            <div className={classes.extras}>
                                {extrasDisponiveis.map((acao) => (
                                    <FormControlLabel
                                        key={acao.id}
                                        control={
                                            <Checkbox
                                                checked={acoesExtras.includes(acao.id)}
                                                onChange={() => alternarExtra(acao.id)}
                                            />
                                        }
                                        label={acao.descricao || acao.id}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </section>

                <div className={classes.actions}>
                    <Button variant="contained" color="primary" onClick={handleSave}>
                        Salvar
                    </Button>
                </div>
            </form>
        </Container>
    )
}


export  default FormUser;